var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirham(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08366 15.8333H4.16699",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16574 13.7324C7.0245 13.5804 6.84764 13.4659 6.65111 13.3994C6.45458 13.3328 6.24457 13.3162 6.04002 13.351C5.83546 13.3859 5.64281 13.4711 5.47942 13.599C5.31604 13.7269 5.18707 13.8935 5.10415 14.0837C5.02123 14.2739 4.98696 14.4818 5.00445 14.6886C5.02193 14.8953 5.09061 15.0945 5.20429 15.2681C5.31798 15.4417 5.47309 15.5842 5.65563 15.6829C5.83817 15.7816 6.04241 15.8332 6.24991 15.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 3.33325V10.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333H14.0733C14.2933 10.8333 14.5093 10.7753 14.6997 10.6652C14.8901 10.5551 15.048 10.3966 15.1576 10.2059C15.2671 10.0152 15.3244 9.79895 15.3237 9.57901C15.3229 9.35907 15.2642 9.14322 15.1533 8.95325L13.3333 5.83325",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 10.8416V10.8333",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirham);
export default __webpack_public_path__ + "static/media/dirham.9730d3463e0774f02d67cc9752e3a8bc.svg";
export { ForwardRef as ReactComponent };